<template>
  <collapsed-card
    icon="md-information-circle"
    title="Дополнительные сведения"
    :is-hiding="true"
  >
    <inline-loader :loading="loading" v-if="loading" />
    <ul class="contract-subinfo" v-else>
      <li
        class="contract-subinfo__row"
        v-for="item in subInfoRows"
        :key="item.value"
      >
        <div class="contract-subinfo__title-cell ms-help">
          {{ item.title }}
        </div>
        <div class="contract-subinfo__value-cell">
          <span :class="getValueClass(item)">
            {{ getPropValue(item) }}
          </span>
          <span
            class="ms-link"
            v-if="isValueLong(item)"
            @click="isAllInfoShow = !isAllInfoShow"
          >
            {{ isAllInfoShow ? "Скрыть все" : "Показать все" }}
          </span>
        </div>
      </li>
      <li class="contract-subinfo__row" v-if="contract.expert_date">
        <div class="contract-subinfo__title-cell ms-help">Срок экспертизы</div>
        <div class="contract-subinfo__value-cell">
          <span class="contract-subinfo__value-content ms-text">
            {{ contract.expert_date }}
          </span>
        </div>
      </li>
    </ul>

    <i-button
      type="text"
      class="collapsed-card-button ms-link"
      slot="dropdown"
      @click="editClickHandler"
      v-if="getContractModulePerms('contract_sub_info', 'update')"
    >
      Редактировать
    </i-button>

    <modal
      v-model="editModal"
      width="540"
      :styles="{ top: '40px' }"
      :mask-closable="false"
    >
      <div slot="header" class="law-cases-editor__header">
        <icon size="16" type="md-information-circle" class="ms-help" />
        <span style="margin-left: 4px" class="ms-help">
          Редактирование дополнительных сведений
        </span>
      </div>
      <contract-subinfo :contract="editingContract" />
      <div slot="footer" class="contract-subinfo-edit">
        <i-button type="success" size="small" :loading="saving" @click="save">
          Сохранить
        </i-button>
      </div>
    </modal>
  </collapsed-card>
</template>

<script>
import cloneDeep from 'lodash.clonedeep'
import CollapsedCard from '@/components/parts/collapsed-card'
import InlineLoader from '@/components/loaders/inline-loader'
import ContractSubinfo from '@/components/contract-editor/steps/sub-info'
import { subInfoRows } from '@/config/contracts'
import { getNewComplexValues } from '@/utils'

export default {
  components: {
    CollapsedCard,
    InlineLoader,
    ContractSubinfo
  },
  data () {
    return {
      loading: false,
      contract: {},
      editingContract: {},
      editModal: false,
      saving: false,
      inititalObjectTypes: [],
      initialTerritoryTypes: [],
      initialOffshoreDrillings: [],
      initialLevels: [],
      initialStages: [],
      initialClimateConditions: [],
      isAllInfoShow: false,
      subInfoRows
    }
  },
  methods: {
    getValueClass ({ type, propName }) {
      const colorClass =
        type !== 'boolean' && !this.contract[propName]
          ? 'ms-danger'
          : 'ms-text'

      return this.isAllInfoShow
        ? `contract-subinfo__value-content ${colorClass}`
        : `contract-subinfo__value-content hidden ${colorClass}`
    },
    isValueLong ({ propName }) {
      if (propName !== 'description') return false

      const value = this.contract[propName]

      return String(value).length > 100
    },
    getPropValue ({ type, propName }) {
      if (type === 'boolean') return this.contract[propName] ? 'Да' : 'Нет'

      return this.contract[propName] ? this.contract[propName] : 'Не указано'
    },
    async getData () {
      const { id } = this.$route.params

      try {
        this.loading = true
        const url = `page/project/${id}?format=additional`
        this.contract = await this.$store.dispatch('GET_REQUEST', { url })
        this.editingContract = cloneDeep(this.contract)
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async getEditingData () {
      const { id } = this.$route.params

      try {
        const config = {
          where: [
            {
              field: 'id',
              op: '=',
              value: id,
              type: 'AND'
            }
          ],
          include: {
            contract_object_types: {},
            contract_territory_types: {},
            contract_responsibility_levels: {},
            contract_project_stages: {},
            contract_climate_conditions: {},
            contract_offshore_drillings: {}
          }
        }
        const url = `objectInfo/contracts?config=${JSON.stringify(config)}`
        const data = await this.$store.dispatch('GET_REQUEST', { url })
        const contract = data[0]

        // set initial complex attributes values
        this.inititalObjectTypes = cloneDeep(contract.contract_object_types)
        contract.contract_object_types = contract.contract_object_types.map(
          (t) => t.object_type_id
        )
        this.initialTerritoryTypes = cloneDeep(
          contract.contract_territory_types
        )
        contract.contract_territory_types = contract.contract_territory_types.map(
          (t) => t.territory_type_id
        )
        this.initialOffshoreDrillings = cloneDeep(
          contract.contract_offshore_drillings
        )
        contract.contract_offshore_drillings = contract.contract_offshore_drillings.map(
          (t) => t.offshore_drilling_id
        )
        this.initialLevels = cloneDeep(contract.contract_responsibility_levels)
        contract.contract_responsibility_levels = contract.contract_responsibility_levels.map(
          (l) => l.responsibility_level_id
        )
        this.initialStages = cloneDeep(contract.contract_project_stages)
        contract.contract_project_stages = contract.contract_project_stages.map(
          (s) => s.project_stage_id
        )
        this.initialClimateConditions = cloneDeep(
          contract.contract_climate_conditions
        )
        contract.contract_climate_conditions = contract.contract_climate_conditions.map(
          (s) => s.climate_condition_id
        )

        this.editingContract = cloneDeep(data[0])
      } catch (error) {
        console.log(error)
      }
    },
    async editClickHandler () {
      await this.getEditingData()
      this.editModal = true
    },
    parseEditedData () {
      const {
        contract_object_types,
        contract_territory_types,
        contract_offshore_drillings,
        contract_project_stages,
        contract_responsibility_levels,
        contract_climate_conditions
      } = this.editingContract

      return {
        ...this.editingContract,
        contract_object_types: getNewComplexValues(
          contract_object_types,
          this.inititalObjectTypes,
          'object_type_id'
        ),
        contract_territory_types: getNewComplexValues(
          contract_territory_types,
          this.initialTerritoryTypes,
          'territory_type_id'
        ),
        contract_offshore_drillings: getNewComplexValues(
          contract_offshore_drillings,
          this.initialOffshoreDrillings,
          'offshore_drilling_id'
        ),
        contract_responsibility_levels: getNewComplexValues(
          contract_responsibility_levels,
          this.initialLevels,
          'responsibility_level_id'
        ),
        contract_project_stages: getNewComplexValues(
          contract_project_stages,
          this.initialStages,
          'project_stage_id'
        ),
        contract_climate_conditions: getNewComplexValues(
          contract_climate_conditions,
          this.initialClimateConditions,
          'climate_condition_id'
        )
      }
    },
    async save () {
      try {
        this.saving = true
        const url = `page/project`
        const data = this.parseEditedData()

        await this.$store.dispatch('POST_REQUEST', { url, data })
        await this.getData()
        this.$Message.success('Сохранение данных выполнено успешно')
        this.editModal = false
        this.saving = false
      } catch (error) {
        console.log(error)
        this.$Message.error('Произошла ошибка при сохранении данных')
        this.saving = false
      }
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style lang="less">
.contract-subinfo {
  &__row {
    display: flex;
    justify-content: space-between;

    &:not(:first-child) {
      margin-top: 4px;
    }
  }

  &__title-cell {
    width: 40%;
    margin-right: 16px;
    flex-shrink: 0;
  }

  &__value-cell {
    flex: 1;
    display: flex;
    flex-direction: column;

    .ms-link {
      cursor: pointer;
      margin-top: 4px;
    }
  }

  &__value-content {
    word-break: break-word;
    flex: 1;

    &.hidden {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 5;
      overflow: hidden;
    }
  }
}
</style>
